export const ECR_COMPONENTS_GRID_VIEW = 'grid-view';
export const ECR_COMPONENTS_LIST_VIEW = 'list-view';

export const ECR_COMPONENT_INSTALLATION_STATUS_CREATED = 'INSTALL_CREATED';
export const ECR_COMPONENT_INSTALLATION_STATUS_IN_PROGRESS = 'INSTALL_IN_PROGRESS';
export const ECR_COMPONENT_INSTALLATION_STATUS_COMPLETED = 'INSTALL_COMPLETED';
export const ECR_COMPONENT_INSTALLATION_STATUS_ERROR = 'INSTALL_ERROR';
export const ECR_COMPONENT_INSTALLATION_STATUS_ROLLBACK = 'INSTALL_ROLLBACK';

export const ECR_COMPONENT_UNINSTALLATION_STATUS_CREATED = 'UNINSTALL_CREATED';
export const ECR_COMPONENT_UNINSTALLATION_STATUS_IN_PROGRESS = 'UNINSTALL_IN_PROGRESS';
export const ECR_COMPONENT_UNINSTALLATION_STATUS_COMPLETED = 'UNINSTALL_COMPLETED';
export const ECR_COMPONENT_UNINSTALLATION_STATUS_PARTIAL_COMPLETED = 'UNINSTALL_PARTIAL_COMPLETED';
export const ECR_COMPONENT_UNINSTALLATION_STATUS_ERROR = 'UNINSTALL_ERROR';
export const ECR_COMPONENT_CURRENT_JOB_STATUS_INSTALLING = 'installing';
export const ECR_COMPONENT_CURRENT_JOB_STATUS_UNINSTALLING = 'uninstalling';
